export const MAX_SEARCH_HOTEL_DAYS = 28;
